import {
  LoadingContainer,
  LegacyPage,
  Model,
  Panels,
  Bar,
} from 'peach/components'
import { useParams } from 'peach/router'

import { useDrawBalancesGet } from 'core/types'

const DrawBalances = () => {
  const { personId, loanId, drawId } = useParams<{
    personId?: string
    loanId?: string
    drawId?: string
  }>()

  const {
    data: balances,
    isLoading,
    error,
  } = useDrawBalancesGet({
    personId,
    loanId,
    drawId,
    options: { enabled: !!(personId && loanId && drawId) },
  })

  return (
    <Panels header={<Bar title='Balances' />}>
      <LoadingContainer error={error} isLoading={isLoading}>
        <LegacyPage.Full>
          <Model.Item json={balances} />
        </LegacyPage.Full>
      </LoadingContainer>
    </Panels>
  )
}

export default DrawBalances
